import planBridge, { BridgeEventValue } from '@atlassian/jira-portfolio-3-bridge/src/index.tsx';

const resetCustomFields = () => {
	planBridge.dispatchBridgeEvent(BridgeEventValue.RESET_CUSTOM_FIELDS, {});
};

export default resetCustomFields;
